export enum ListingSearchType {
  MyListingsOnly = 'MyListingsOnly',
  AllListings = 'AllListings'
}

export const ListingSearchTypes: ListingSearchType[] = [ListingSearchType.MyListingsOnly, ListingSearchType.AllListings];
